/**
 * <header-cart-hover>
 *
 * Hovering the cart icon opens a fixed side drawer showing cart
 * contents, with a dimming overlay behind it — matching the Cartier
 * reference (icon stays small, hover reveals the panel). Desktop
 * hover only; below the header's own 990px mobile breakpoint (or on
 * touch/coarse-pointer devices of any width) it falls back to a
 * tap-to-open toggle instead, so the mobile view never triggers the
 * hover panel even when tested on a resized desktop browser window
 * (which still reports a fine pointer/hover capability).
 */
if (!customElements.get('header-cart-hover')) {
  customElements.define(
    'header-cart-hover',
    class HeaderCartHover extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.header__icon--cart');
        this.closeButton = this.querySelector('.header-cart-hover__close');
        this.overlay = this.querySelector('.header-cart-hover__overlay');
        this.mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
        this.openTimer = null;
        this.closeTimer = null;

        this.onPointerEnter = () => {
          if (!this.mq.matches) return;
          clearTimeout(this.closeTimer);
          this.openTimer = setTimeout(() => this.open(), 80);
        };
        this.onPointerLeave = () => {
          if (!this.mq.matches) return;
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => this.close(), 250);
        };
        this.onTriggerClick = (event) => {
          if (this.mq.matches) {
            // Hover already opens it on desktop — clicking should still
            // navigate to the cart page rather than being intercepted.
            return;
          }
          event.preventDefault();
          this.classList.contains('is-open') ? this.close() : this.open();
        };
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };
        this.onDocumentClick = (event) => {
          if (this.mq.matches) return;
          if (!this.contains(event.target)) this.close();
        };

        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.trigger?.addEventListener('click', this.onTriggerClick);
        this.closeButton?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        document.removeEventListener('click', this.onDocumentClick);
      }

      open() {
        this.classList.add('is-open');
      }

      close() {
        this.classList.remove('is-open');
      }
    }
  );
}
